import { render, staticRenderFns } from "./CoorForm.vue?vue&type=template&id=ef72f1f8&"
import script from "./CoorForm.vue?vue&type=script&lang=js&"
export * from "./CoorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports